import { authenticatedGet, authenticatedPost, authenticatedPatch } from "../../api/authenticatedFetch";
const BASE = "/api/v1";
export const listInvestigations = () => authenticatedGet(`${BASE}/investigations`);
export const getInvestigation = (id) => authenticatedGet(`${BASE}/investigations/${id}`);
export const createInvestigation = (title, seed) => authenticatedPost(`${BASE}/investigations`, { title, seed });
export const previewInvestigation = (seed) => authenticatedPost(`${BASE}/investigations/preview`, seed);
export const rerunInvestigation = (id) => authenticatedPost(`${BASE}/investigations/${id}/rerun`, {});
export const patchInvestigation = (id, patch) => authenticatedPatch(`${BASE}/investigations/${id}`, patch);
export const createAction = (id, kind, targetRef) => authenticatedPost(`${BASE}/investigations/${id}/actions`, { kind, targetRef });
